/**
 * Export i18n texts as object.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * Texts for i18n.
 *
 * @type {Object}
 */
export const I18N = {
	prev  : 'Previous slide',
	next  : 'Next slide',
	first : 'Go to first slide',
	last  : 'Go to last slide',
	slideX: 'Go to slide %s',
	pageX : 'Go to page %s',
	play  : 'Start autoplay',
	pause : 'Pause autoplay',
};